import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./VerifyPhoneNumberModal.css";

const VerifyPhoneNumberModal = ({ show, handleClose, openPhoneModal }) => {
  const inputRefs = useRef([]);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(true);

  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleResendOTP = () => {
    console.log("Resend OTP API");

    // Call your resend OTP API here

    setCanResend(false);
    setTimer(60);
  };

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");

    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] !== "") {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };
  const handleVerify = () => {
    console.log("OTP :", otp.join(""));

    // Verify API

    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal verify-phone-modal"
    >
      <Modal.Header className="verify-header">
        <Modal.Title>Verify phone number</Modal.Title>

        <button className="btn-close" onClick={handleClose}></button>
      </Modal.Header>

      <Modal.Body className="verify-body">
        <p className="verify-text">
          We've sent a verification code to your mobile number
        </p>

        <div
          className="phone-number"
          onClick={openPhoneModal}
          style={{ cursor: "pointer" }}
        >
          +91 8329717621
          <span className="edit-icon">✏️</span>
        </div>

        <div className="otp-container">
          {otp.map((digit, index) => (
            <Form.Control
              key={index}
              type="text"
              value={digit}
              maxLength={1}
              className="otp-input"
              ref={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          ))}
        </div>

        <div className="resend-text">
          Didn't receive your OTP?{" "}
          {canResend ? (
            <span className="resend-link" onClick={handleResendOTP}>
              Resend OTP
            </span>
          ) : (
            <span className="timer">Resend OTP ({timer}s)</span>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="verify-footer">
        <Button className="verify-btn" onClick={handleVerify}>
          Verify
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VerifyPhoneNumberModal;
